module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_cookie_policy", [["div",{"class":"pad-lr pad-tb"},[["div",{"class":"global-title text-color-2"},[["h2",{"data-fox-alias":"cookieTitle","data-fox-context":"personal"},[["textNode",{"text":"Cookie Use Policy"}]]]]],["div",{"data-fox-alias":"cookieText","class":"static-page-docs"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/cookie.tpl
// module id = 1202
// module chunks = 4